// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39Jzb","inner":"Footer_inner__2hKut","nextIcon":"Footer_nextIcon__3oRYE","innerLeft":"Footer_innerLeft__1oT19"};